// https://g.alicdn.com/dingding/dinglogin/0.0.5/ddLogin.js
export default class DingtalkLoginApi {
    static qrcode(options: DingtalkLoginQrcodeOptions) {
        let element = document.getElementById(options.id ?? "login_container")!,
            iframe = document.createElement("iframe"),
            url = "https://login.dingtalk.com/login/qrcode.htm?goto=" + options.goto

        url += '&style=' + encodeURIComponent(options.style ?? "border:none; background-color:#FFFFFF;")
        url += options.href ? "&href=" + options.href : ""
        iframe.src = url
        iframe.frameBorder = "0"
        // @ts-ignore
        iframe.allowTransparency = "true"
        iframe.scrolling = "no"
        iframe.width = options.width ?? "300"
        iframe.height = options.height ?? "300"

        element.innerHTML = ""
        element.appendChild(iframe)
    }
}

export class DingtalkLoginQrcodeOptions {
    id?: string
    goto!: string
    style?: string
    width?: string
    height?: string
    href?: string
}
